import React, { ButtonHTMLAttributes } from "react";

import classnames from "classnames/bind";

import styles from "./WideButton.module.scss";

const cx: CX = classnames.bind(styles);

function WideButton(props: Props) {
    const { title, disabled, onClick, ...rest } = props;

    function handleClick() {
        if (!disabled) {
            onClick();
        }
    }

    return (
        <button
            type="button"
            className={cx("wide-button")}
            onClick={handleClick}
            disabled={disabled}
            {...rest}
        >
            {title}
        </button>
    );
}

type Props = {
    title: string;
    onClick: () => void;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export default WideButton;
